/*
 * Baby Doo mobile menu / drawer scroll-lock fix (v2).
 *
 * Symptom: on mobile, opening the burger menu and then closing it left the page
 * unable to scroll. Cause: the theme locks scrolling by putting `modal-show` /
 * `modal-showing` on <body> (both apply `overflow:hidden`). `modal-showing` is
 * added at the very start of opening and is only removed once the open animation
 * finishes (handleAfterShow). On a quick open-then-close, the open animation is
 * cut short, handleAfterShow never completes, and `modal-showing` stays on <body>
 * forever, so the page can no longer scroll even though nothing is open.
 *
 * Why v1 did nothing: the theme's ModalComponent / clearModalComponentCount are
 * NOT globals (they live inside a module scope), so `typeof ModalComponent` was
 * 'undefined' and the old script silently no-opped.
 *
 * Fix: reach ModalComponent.prototype through the registered custom element
 * (customElements.get('drawer-component') -> its prototype's prototype). After a
 * drawer closes, if no locking drawer/modal is actually open in the DOM, force
 * both lock classes off <body>. This never affects the open state (scroll stays
 * locked while a drawer is genuinely open) and touches nothing else.
 */
(function () {
  function anyLockingOpen() {
    return (
      document.querySelectorAll(
        'menu-drawer[open], cart-drawer[open], [is="cart-drawer"][open], quick-view-modal[open], basic-modal[open], modal-component[open]'
      ).length > 0
    );
  }

  function clearIfNothingOpen() {
    if (!anyLockingOpen()) {
      document.body.classList.remove('modal-show');
      document.body.classList.remove('modal-showing');
    }
  }

  function applyFix() {
    var DrawerComponent = window.customElements && customElements.get('drawer-component');
    if (!DrawerComponent || !DrawerComponent.prototype) return false;

    var modalProto = Object.getPrototypeOf(DrawerComponent.prototype); // ModalComponent.prototype
    if (!modalProto || typeof modalProto.handleAfterHide !== 'function') return false;
    if (modalProto.__bdPatched) return true;
    modalProto.__bdPatched = true;

    var origHide = modalProto.handleAfterHide;
    modalProto.handleAfterHide = function () {
      try {
        origHide.apply(this, arguments);
      } catch (e) {}
      setTimeout(clearIfNothingOpen, 60);
    };

    // Extra safety net: any time a menu-drawer's open attribute is toggled off,
    // re-check and clear a stuck lock. Covers animation-interrupted closes.
    document.addEventListener(
      'toggle',
      function (e) {
        var t = e.target;
        if (t && t.tagName === 'MENU-DRAWER' && !t.hasAttribute('open')) {
          setTimeout(clearIfNothingOpen, 60);
        }
      },
      true
    );

    return true;
  }

  // The custom element may not be defined the instant this script runs; wait for it.
  if (!applyFix()) {
    var done = false;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('drawer-component').then(function () {
        done = applyFix() || done;
      });
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (applyFix() || done || tries > 100) clearInterval(timer);
    }, 50);
  }
})();
